import ContentLoader from "react-content-loader"

import "./Loader.scss"

export const ConfirmVehicleLoader = () => {
  return (
    <div className="confirm-vehicle">
      <ContentLoader className="loader" speed={2} width={450} height={600} viewBox="0 0 450 600">
        <circle cx="225" cy="200" r="150" />
        <rect x="120" y="380" rx="5" ry="5" width="220" height="50" />
        <rect x="0" y="450" rx="5" ry="5" width="460" height="30" />
        <rect x="0" y="485" rx="5" ry="5" width="450" height="25" />
        <rect x="80" y="530" rx="5" ry="5" width="300" height="20" />
      </ContentLoader>
    </div>
  )
}
